import React, { useState, useEffect } from 'react';
import '../assets/styles/CadastroProdutor.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Tela de cadastro de Povoado integrada com API
export default function CadastroPovoado() {
  const [povoado, setPovoado] = useState({
    nome: '',
    regiao_id: '',
    latitude: '',
    longitude: ''
  });
  const [povoados, setPovoados] = useState([]);
  const [regioes, setRegioes] = useState([]);
  const [editId, setEditId] = useState(null);
  const [mensagem, setMensagem] = useState(null);

  // Buscar povoados da API ao carregar
  useEffect(() => {
    fetch(`${API_BASE_URL}/povoados/`)
      .then(res => res.json())
      .then(data => {
        console.log('Dados de povoados recebidos:', data);
        setPovoados(Array.isArray(data.productId) ? data.productId : []);
      })
      .catch(() => setMensagem('Erro ao buscar povoados.'));
  }, []);

  // Buscar regiões da API ao carregar
  useEffect(() => {
    fetch(`${API_BASE_URL}/regioes/`)
      .then(res => res.json())
      .then(data => {
        console.log('Dados de regiões recebidos:', data);
        setRegioes(Array.isArray(data.productId) ? data.productId : []);
      })
      .catch(() => setMensagem('Erro ao buscar regiões.'));
  }, []);

  // Função para obter o nome da região pelo ID
  const getNomeRegiao = (regiao_id) => {
    console.log('Buscando região para ID:', regiao_id, 'Regiões disponíveis:', regioes);
    if (!regiao_id) return '-';
    const regiao = regioes.find(r => r.id === regiao_id || r.id === parseInt(regiao_id));
    return regiao ? regiao.nome : 'Região não encontrada';
  };

  // Função para editar povoado
  const handleEdit = (id) => {
    if (editId === id) {
      // Se já estiver no modo de edição, limpa os inputs e volta ao modo de cadastro
      setPovoado({ nome: '', regiao_id: '', latitude: '', longitude: '' });
      setEditId(null);
      setMensagem(null);
    } else {
      const p = povoados.find(p => p.id === id);
      if (p) {
        setPovoado({ 
          nome: p.nome || '',
          regiao_id: p.regiao_id || '',
          latitude: p.latitude || '',
          longitude: p.longitude || ''
        });
        setEditId(id);
        setMensagem(null);
        console.log('Editando povoado:', p);
      } else {
        setMensagem('❌ Povoado não encontrado para edição.');
      }
    }
  };

  // Função para deletar povoado via API
  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este povoado?')) {
      return;
    }

    try {
      console.log('Deletando povoado com ID:', id);
      const res = await fetch(`${API_BASE_URL}/povoados/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
      });
      
      console.log('Resposta da API delete:', res.status);
      
      if (res.ok) {
        setPovoados(povoados.filter(p => p.id !== id));
        setMensagem('✅ Povoado removido com sucesso!');
        if (editId === id) {
          setEditId(null);
          setPovoado({ nome: '', regiao_id: '', latitude: '', longitude: '' });
        }
      } else {
        const errorData = await res.text();
        console.error('Erro ao deletar:', errorData);
        setMensagem('❌ Erro ao remover povoado.');
      }
    } catch (error) {
      console.error('Erro ao deletar povoado:', error);
      setMensagem('❌ Erro ao remover povoado.');
    }
  };

  // Função para obter localização atual
  const obterLocalizacaoAtual = () => {
    if (!navigator.geolocation) {
      setMensagem('❌ Geolocalização não é suportada pelo seu navegador.');
      return;
    }

    setMensagem('📍 Obtendo localização...');
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude.toFixed(6);
        const lng = position.coords.longitude.toFixed(6);
        setPovoado({
          ...povoado,
          latitude: lat,
          longitude: lng
        });
        setMensagem('✅ Localização obtida com sucesso!');
      },
      (error) => {
        let mensagemErro = '❌ Erro ao obter localização: ';
        switch(error.code) {
          case error.PERMISSION_DENIED:
            mensagemErro += 'Permissão negada pelo usuário.';
            break;
          case error.POSITION_UNAVAILABLE:
            mensagemErro += 'Localização indisponível.';
            break;
          case error.TIMEOUT:
            mensagemErro += 'Tempo limite excedido.';
            break;
          default:
            mensagemErro += 'Erro desconhecido.';
            break;
        }
        setMensagem(mensagemErro);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  };

  // Função para validar coordenadas
  const validarCoordenadas = (lat, lng) => {
    const latitude = parseFloat(lat);
    const longitude = parseFloat(lng);
    
    if (lat && (isNaN(latitude) || latitude < -90 || latitude > 90)) {
      return 'Latitude deve estar entre -90 e 90 graus';
    }
    
    if (lng && (isNaN(longitude) || longitude < -180 || longitude > 180)) {
      return 'Longitude deve estar entre -180 e 180 graus';
    }
    
    return null;
  };

  const handleChange = e => {
    let value = e.target.value;
    
    // Se for um campo de coordenada, limpar caracteres especiais e converter
    if (e.target.name === 'latitude' || e.target.name === 'longitude') {
      // Remove símbolos especiais como ‑ (hífen em dash), °, espaços extras
      value = value.replace(/[‑−°\s]/g, ''); // Remove hífen especial, graus, espaços
      value = value.replace(/[^\d.,-]/g, ''); // Mantém apenas números, ponto, vírgula e hífen normal
      value = value.replace(/,/g, '.'); // Substitui vírgula por ponto
      
      // Se começar com hífen, manter o sinal negativo
      if (e.target.value.startsWith('‑') || e.target.value.startsWith('−') || e.target.value.startsWith('-')) {
        value = '-' + value.replace(/^-+/, '');
      }
    }
    
    setPovoado({ ...povoado, [e.target.name]: value });
  };

  // Ao enviar o formulário
  const handleSubmit = async e => {
    e.preventDefault();
    
    // Validar coordenadas antes de enviar
    const erroValidacao = validarCoordenadas(povoado.latitude, povoado.longitude);
    if (erroValidacao) {
      setMensagem(`❌ ${erroValidacao}`);
      return;
    }
    
    if (editId) {
      // Atualizar povoado existente
      try {
        // Recupera a data_cadastro original
        const povoadoAntigo = povoados.find(p => p.id === editId);
        const dataCadastroOriginal = povoadoAntigo && povoadoAntigo.data_cadastro ? povoadoAntigo.data_cadastro : undefined;
        console.log('Atualizando povoado:', { id: editId, ...povoado });
        const res = await fetch(`${API_BASE_URL}/povoados/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: editId,
            nome: povoado.nome,
            regiao_id: povoado.regiao_id,
            latitude: povoado.latitude,
            longitude: povoado.longitude,
            data_cadastro: dataCadastroOriginal
          })
        });
        
        console.log('Resposta da atualização:', res.status);
        
        if (res.ok) {
          // Atualizar o povoado na lista local
          const povoadoAtualizado = {
            id: editId,
            nome: povoado.nome,
            regiao_id: povoado.regiao_id,
            latitude: povoado.latitude,
            longitude: povoado.longitude,
            data_cadastro: dataCadastroOriginal
          };
          setPovoados(povoados.map(p => (p.id === editId ? povoadoAtualizado : p)));
          setMensagem('✅ Povoado atualizado com sucesso!');
          setEditId(null);
          setPovoado({ nome: '', regiao_id: '', latitude: '', longitude: '' });
        } else {
          const errorData = await res.text();
          console.error('Erro na atualização:', errorData);
          setMensagem('❌ Erro ao atualizar povoado.');
        }
      } catch (error) {
        console.error('Erro ao atualizar povoado:', error);
        setMensagem('❌ Erro ao atualizar povoado.');
      }
    } else {
      // Criar novo povoado
      try {
        const res = await fetch(`${API_BASE_URL}/povoados/add`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            nome: povoado.nome,
            regiao_id: povoado.regiao_id,
            latitude: povoado.latitude,
            longitude: povoado.longitude
          })
        });
        if (res.ok) {
          const result = await res.json();
          console.log('Resultado da criação:', result);
          // Buscar o povoado recém cadastrado pelo id retornado
          if (result && result.productId) {
            try {
              const resPovoado = await fetch(`${API_BASE_URL}/povoados/${result.productId}`);
              const povoadoData = await resPovoado.json();
              console.log('Dados do povoado criado:', povoadoData);
              if (povoadoData && Array.isArray(povoadoData.povoados) && povoadoData.povoados.length > 0) {
                setPovoados([...povoados, povoadoData.povoados[0]]);
              } else {
                // Fallback: adicionar com os dados locais
                const novoPovoado = {
                  id: result.productId,
                  nome: povoado.nome,
                  regiao_id: povoado.regiao_id,
                  latitude: povoado.latitude,
                  longitude: povoado.longitude
                };
                setPovoados([...povoados, novoPovoado]);
              }
            } catch (fetchError) {
              console.error('Erro ao buscar povoado criado:', fetchError);
              // Fallback: adicionar com os dados locais
              const novoPovoado = {
                id: result.productId,
                nome: povoado.nome,
                regiao_id: povoado.regiao_id,
                latitude: povoado.latitude,
                longitude: povoado.longitude
              };
              setPovoados([...povoados, novoPovoado]);
            }
          }
          setMensagem('✅ Povoado cadastrado com sucesso!');
          setPovoado({ nome: '', regiao_id: '', latitude: '', longitude: '' });
        } else {
          const errorData = await res.text();
          console.error('Erro na criação:', errorData);
          setMensagem('❌ Erro ao cadastrar povoado.');
        }
      } catch (error) {
        console.error('Erro ao cadastrar povoado:', error);
        setMensagem('❌ Erro ao cadastrar povoado.');
      }
    }
  };

  return (
    <div className="cadastro-produtor-container">
      <h2>Cadastro de Povoado</h2>
      <div className="cadastro-form">
        <form onSubmit={handleSubmit} style={{marginBottom: 32}}>
          <fieldset>
            <legend>Dados do Povoado</legend>
            <label htmlFor="nome">Nome</label>
            <input id="nome" name="nome" value={povoado.nome} onChange={handleChange} required />
            <label htmlFor="regiao_id">Região</label>
            <select id="regiao_id" name="regiao_id" value={povoado.regiao_id} onChange={handleChange} required>
              <option value="">Selecione</option>
              {regioes.map(r => (
                <option key={r.id} value={r.id}>{r.nome}</option>
              ))}
            </select>
            <label htmlFor="latitude">Latitude (ex: -10.97157)</label>
            <input 
              id="latitude" 
              name="latitude" 
              value={povoado.latitude} 
              onChange={handleChange}
              placeholder="-10.97157"
              title="Digite a latitude no formato decimal (ex: -10.97157)"
            />
            <label htmlFor="longitude">Longitude (ex: -37.6340)</label>
            <input 
              id="longitude" 
              name="longitude" 
              value={povoado.longitude} 
              onChange={handleChange}
              placeholder="-37.6340"
              title="Digite a longitude no formato decimal (ex: -37.6340)"
            />
            <div style={{margin: '10px 0'}}>
              <button 
                type="button" 
                onClick={obterLocalizacaoAtual}
                style={{
                  padding: '8px 16px',
                  background: '#10b981',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                📍 Usar Localização Atual
              </button>
            </div>
          </fieldset>
          <button type="submit" className="btn-cadastrar">{editId ? 'Atualizar' : 'Cadastrar'}</button>
          {mensagem && <p className="mensagem-sucesso">{mensagem}</p>}
        </form>

        {/* Tabela de povoados cadastrados */}
        <div style={{width: '100%', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px #0001', border: '1px solid #e0e0e0', padding: 24, marginBottom: 32}}>
          <h3>Últimos 5 Povoados Cadastrados</h3>
          <p style={{margin: '0 0 12px 0', color: '#555', fontSize: 14}}>
            A tabela abaixo mostra apenas os 5 povoados mais recentemente cadastrados no sistema, considerando o maior ID como o mais novo.
          </p>
          <div style={{width: '100%', overflowX: 'auto'}}>
            <table style={{width: '100%', maxWidth: '100%', borderCollapse: 'collapse', tableLayout: 'auto'}}>
              <thead>
                <tr style={{ background: '#f7fafc' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Nome</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Região</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Latitude</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Longitude</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {povoados
                  .slice()
                  .sort((a, b) => b.id - a.id)
                  .slice(0, 5)
                  .map(p => (
                    <tr key={p.id} style={{ background: '#fff' }}>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{p.nome}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{getNomeRegiao(p.regiao_id)}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{p.latitude}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{p.longitude}</td>
                      <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>
                        <button onClick={() => handleEdit(p.id)} className="btn-acao" style={{marginRight: 8}}>Editar</button>
                        <button onClick={() => handleDelete(p.id)} className="btn-acao excluir">Excluir</button>
                      </td>
                    </tr>
                  ))}
                {povoados.length === 0 && (
                  <tr><td colSpan={5} style={{textAlign: 'center', color: '#888'}}>Nenhum povoado cadastrado.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="info-section">
          <h3>Informações sobre Povoados</h3>
          <div className="info-card">
            <h4>🗺️ Coordenadas GPS</h4>
            <p>
              <strong>Formato correto:</strong> Use números decimais com ponto (ex: -10.97157, -37.6340)<br/>
              <strong>Latitude:</strong> Entre -90 e 90 graus (negativo = Sul, positivo = Norte)<br/>
              <strong>Longitude:</strong> Entre -180 e 180 graus (negativo = Oeste, positivo = Leste)<br/>
              <strong>Dica:</strong> Use o botão "📍 Usar Localização Atual" para obter as coordenadas automaticamente
            </p>
          </div>
          <div className="info-card">
            <h4>📍 Região</h4>
            <p>Cada povoado deve estar vinculado a uma região. Certifique-se de que a região foi cadastrada previamente no sistema.</p>
          </div>
          <div className="info-card">
            <h4>👥 Famílias</h4>
            <p>Após cadastrar o povoado, será possível vincular famílias a este local para controle de produção e atividades agrícolas.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
